<template>
  <div class="banner" ref="banner">
    <div
      v-if="overflowing"
      class="marquee-track"
      :style="trackStyle"
    >
      <div class="marquee-item" ref="item">
        <span class="title" v-html="parseMarkdown(title).html"></span>
        <h3 class="separator"> : </h3>
        <span class="message" v-html="parseMarkdown(message).html"></span>
      </div>
    </div>
    <div
      v-else
      class="static-text text-body-2 text-grey-darken-4 ml-2"
      ref="item"
      v-html="parsed.html"
    ></div>

    <div class="banner-links mr-2">
      <v-btn
        v-for="link in parsed.links"
        :key="link.href"
        small
        rounded
        color="white"
        class="btn-no-bold"
        @click="handleLinkClick(link.href)"
      >
        {{ link.text }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import { parseMarkdown } from '@/utils/markdownParser'

export default {
  props: {
    title: { type: String, default: '' },
    message: { type: String, required: true },
    speed: { type: Number, default: 50 },
  },
  data() {
    return {
      duration: 0,
      parsed: { html: '', links: [] },
      overflowing: false
    }
  },
  mounted() {
    this.parseMessage()
    this.measure()
    window.addEventListener('resize', this.measure)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.measure)
  },
  watch: {
    message() {
      this.parseMessage()
      this.$nextTick(this.measure)
    },
    title() {
      this.parseMessage()
      this.$nextTick(this.measure)
    }
  },
  methods: {
    parseMarkdown,
    parseMessage() {
      if (!this.message) {
        this.parsed = { html: '', links: [] }
        return
      }
      const msg = this.title ? `${this.title} : ${this.message}` : this.message
      this.parsed = parseMarkdown(msg)
    },
    measure() {
      this.$nextTick(() => {
        const banner = this.$refs.banner
        const item   = this.$refs.item
        if (!banner || !item) return
        const containerWidth = banner.clientWidth
        const itemWidth      = item.scrollWidth
        this.overflowing = itemWidth > containerWidth*0.5
        if (this.overflowing) {
          const distance = itemWidth + containerWidth
          this.duration = distance / Math.max(this.speed, 1)
        } else {
          this.duration = 0
        }
      })
    },
    handleLinkClick(url) {
      this.$emit('markdown-btn-click', url)
    },
  },
  computed: {
    trackStyle() {
      if (!this.overflowing) return {}
      return {
        animation: `marquee ${this.duration.toFixed(2)}s linear infinite`
      }
    }
  }
}
</script>
<style>
.banner {
  position: relative;
  overflow: hidden;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  padding: 4px 0;
  height: 44px;
}

.static-text {
  display: flex;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 100%;
  padding-top: 20px
}
.static-text p,
.static-text span,
.static-text h1,
.static-text h2,
.static-text h3,
.static-text h4,
.static-text h5,
.static-text h6 {
  margin: 0;
  line-height: 1;
}

.marquee-track {
  display: flex;
  white-space: nowrap;
  will-change: transform;
  height: 100%;
}
.banner:hover .marquee-track {
  animation-play-state: paused !important;
}
.marquee-item {
  display: flex;
  align-items: center;
  height: 100%;
}
.marquee-item p {
  margin: 4px;
}
.marquee-item span {
  display: flex;
  align-items: center;
  height: 100%;
}

.marquee-item span h1,
.marquee-item span h2,
.marquee-item span h3,
.marquee-item span h4,
.marquee-item span h5,
.marquee-item span h6,
.marquee-item span p {
  margin: 0;
  line-height: 1;
}

.banner-links {
  position: absolute;
  right: 0;
  top: 50%;
  align-items: center;
  transform: translateY(-50%);
  display: flex;
  gap: 4px;
}

.btn-no-bold {
  font-weight: normal !important;
  padding: 4px 8px;
}
@keyframes marquee {
  from { transform: translateX(100%); }
  to   { transform: translateX(-100%); }
}
</style>